export default {
  title: {
    ar: 'شكراً لك على إرسال بياناتك',
    en: 'Thank you for submitting your details.'
  },

  back: {
    ar: 'العودة إلى الصفحة الرئيسية',
    en: 'Back to Homepage'
  }
};
